export type ApplicationComponent = {
  component_id: ApplicationComponentId;
  active: boolean;
  parent_id?: ApplicationComponentId;
  properties?: Record<string, any>;
};

export enum ApplicationComponentId {
  /**
   * Home
   */
  HOME = 'HOME',
  /**
   * Carteirinha
   */
  CARD = 'CARD',
  /**
   * Notícias
   */
  NEWS = 'NEWS',
  /**
   * Redes Sociais
   */
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  /**
   * Redes Sociais (feed)
   */
  SOCIAL_MEDIA_FEED = 'SOCIAL_MEDIA_FEED',
  /**
   * Redes Sociais (links)
   */
  SOCIAL_MEDIA_LINKS = 'SOCIAL_MEDIA_LINKS',
  /**
   * Redes Sociais (influences)
   */
  SOCIAL_MEDIA_INFLUENCERS = 'SOCIAL_MEDIA_INFLUENCERS',
  /**
   * Redes Sociais (posts virais x)
   */
  SOCIAL_MEDIA_VIRAL_POSTS = 'SOCIAL_MEDIA_VIRAL_POSTS',

  /**
   * Calendário
   */
  CALENDAR = 'CALENDAR',
  /**
   * Tabelas (aplicativo)
   */
  TABLES = 'TABLES',
  /**
   * Equipes (aplicativo)
   */
  TEAM = 'TEAM',
  /**
   * História (aplicativo)
   */
  HISTORY = 'HISTORY',
  /**
   * Mapa de indicações
   */
  INDICATIONS_MAP = 'INDICATIONS_MAP',
  /**
   * Canal de videos
   */
  VIDEOS_CHANNEL = 'VIDEOS_CHANNEL',
  /**
   * Loja
   */
  STORE = 'STORE',

  /**
   * Loja (produtos)
   */
  STORE_PRODUCTS = 'STORE_PRODUCTS',

  /**
   * Loja (banner)
   */
  STORE_BANNERS = 'STORE_BANNERS',

  /**
   * Clube de beneficios
   */
  BENEFITS_CLUB = 'BENEFITS_CLUB',
  /**
   * Materias exclusivos
   */
  EXCLUSIVE_MATERIAL = 'EXCLUSIVE_MATERIAL',
  /**
   * Calendário de Partidas
   */
  CALENDAR_MATCHES = 'CALENDAR_MATCHES',
  /**
   * Calendário de Eventos
   */
  CALENDAR_EVENTS = 'CALENDAR_EVENTS',
  /**
   * Programação da semana
   */
  CALENDAR_WEEK_SCHEDULE = 'CALENDAR_WEEK_SCHEDULE',
  /**
   * Tabela de classificação
   */
  TABLE_CLASSIFICATION = 'TABLE_CLASSIFICATION',
  /**
   * Tabela de Jogos
   */
  GAME_SCHEDULE = 'GAME_SCHEDULE',
  /**
   * Timeline
   */
  TIMELINE = 'TIMELINE',
  /**
   * Hino
   */
  ANTHEM = 'ANTHEM',
  /**
   * Galerias
   */
  GALLERY = 'GALLERY',
  /**
   * Conquistas
   */
  WON_TITLE = 'WON_TITLE',
  /**
   * Uniformes
   */
  UNIFORMS = 'UNIFORMS',
  /**
   * Banners na Home
   */
  BANNER = 'BANNER',
  /**
   * Influenciaores
   */
  INFLUENCERS = 'INFLUENCERS',
  /**
   * Clube de fidelidade
   */
  LOYALTY = 'LOYALTY',
  /**
   * Área interativa
   */
  INTERACTIVE_AREA = 'INTERACTIVE_AREA',
  /**
   * Área de Posts
   */
  POSTS = 'POSTS',

  /**
   * Área de Quizzes
   */
  QUIZZES = 'QUIZZES',

  /**
   * Área de Enquites
   */
  POLLS = 'POLLS',

  /**
   * Área de Palpitrometro
   */
  PREDICTIONS = 'PREDICTIONS',

  /**
   * Desafios
   */
  CHALLENGE = 'CHALLENGE',

  /**
   * Jogos
   */
  GAMES = 'GAMES',

  /**
   * BaladAPP
   */
  BALADA_APP = 'BALADA_APP',

  /**
   * Páginas do site do parceiro (BaladAPP) como destino de push. Não são áreas
   * configuráveis do app — existem só para o direcionamento de notificação; o
   * app resolve cada id na URL do parceiro (EXPO_PUBLIC_PARTNER_URL) do build.
   */
  BALADA_APP_HOME = 'BALADA_APP_HOME',
  BALADA_APP_ACCOUNT = 'BALADA_APP_ACCOUNT',
  BALADA_APP_PLANS = 'BALADA_APP_PLANS',
  BALADA_APP_GAMES = 'BALADA_APP_GAMES',

  /**
   * Elenco (novo)
   */
  ROSTER = 'ROSTER',
}

export const ApplicationComponentTranslations: Record<ApplicationComponentId, string> = {
  [ApplicationComponentId.HOME]: 'Início',
  [ApplicationComponentId.CARD]: 'Carteirinha',
  [ApplicationComponentId.NEWS]: 'Notícias',
  [ApplicationComponentId.SOCIAL_MEDIA]: 'Redes Sociais',
  [ApplicationComponentId.SOCIAL_MEDIA_FEED]: 'Feed',
  [ApplicationComponentId.SOCIAL_MEDIA_LINKS]: 'Links',
  [ApplicationComponentId.SOCIAL_MEDIA_INFLUENCERS]: 'Influences',
  [ApplicationComponentId.SOCIAL_MEDIA_VIRAL_POSTS]: 'Post Virais',
  [ApplicationComponentId.CALENDAR]: 'Calendário',
  [ApplicationComponentId.TABLES]: 'Tabelas',
  [ApplicationComponentId.TEAM]: 'Equipe',
  [ApplicationComponentId.HISTORY]: 'História',
  [ApplicationComponentId.INDICATIONS_MAP]: 'Mapa de Indicações',
  [ApplicationComponentId.VIDEOS_CHANNEL]: 'Canal de Vídeos',
  [ApplicationComponentId.STORE]: 'Loja',
  [ApplicationComponentId.STORE_BANNERS]: 'Banner principal',
  [ApplicationComponentId.STORE_PRODUCTS]: 'Loja',
  [ApplicationComponentId.BANNER]: 'Banner',
  [ApplicationComponentId.BENEFITS_CLUB]: 'Clube de Benefícios',
  [ApplicationComponentId.EXCLUSIVE_MATERIAL]: 'Materiais Exclusivos',
  [ApplicationComponentId.CALENDAR_MATCHES]: 'Calendário de Partidas',
  [ApplicationComponentId.CALENDAR_EVENTS]: 'Calendário de Eventos',
  [ApplicationComponentId.CALENDAR_WEEK_SCHEDULE]: 'Programação da Semana',
  [ApplicationComponentId.TABLE_CLASSIFICATION]: 'Tabela de Classificação',
  [ApplicationComponentId.GAME_SCHEDULE]: 'Tabela de Jogos',
  [ApplicationComponentId.TIMELINE]: 'Timeline',
  [ApplicationComponentId.ANTHEM]: 'Hino',
  [ApplicationComponentId.GALLERY]: 'Galerias',
  [ApplicationComponentId.WON_TITLE]: 'Conquistas',
  [ApplicationComponentId.UNIFORMS]: 'Uniformes',
  [ApplicationComponentId.INFLUENCERS]: 'Influencers',
  [ApplicationComponentId.LOYALTY]: 'Clube de Fidelidade',
  [ApplicationComponentId.INTERACTIVE_AREA]: 'Área Interativa',
  [ApplicationComponentId.POSTS]: 'Posts',
  [ApplicationComponentId.QUIZZES]: 'Quizzes',
  [ApplicationComponentId.POLLS]: 'Enquetes',
  [ApplicationComponentId.PREDICTIONS]: 'Palpites',
  [ApplicationComponentId.CHALLENGE]: 'Desafios',
  [ApplicationComponentId.GAMES]: 'Jogos',
  [ApplicationComponentId.BALADA_APP]: 'BaladAPP',
  [ApplicationComponentId.BALADA_APP_HOME]: 'Sou Mais Vitória - Página Inicial',
  [ApplicationComponentId.BALADA_APP_ACCOUNT]: 'Sou Mais Vitória - Minha Conta',
  [ApplicationComponentId.BALADA_APP_PLANS]: 'Sou Mais Vitória - Planos',
  [ApplicationComponentId.BALADA_APP_GAMES]: 'Sou Mais Vitória - Jogos',
  [ApplicationComponentId.ROSTER]: 'Elenco (novo)',
};

export const translateApplicationComponentId = (item: ApplicationComponentId): string => {
  return ApplicationComponentTranslations[item] || item;
};

/**
 * Áreas que podem ser destino de uma notificação push.
 *
 * É um subconjunto do enum de propósito: só entra o que tem tela navegável no app.
 * Banners (BANNER, STORE_BANNERS), influencers e as áreas de rede social são
 * elementos de layout — direcionar para eles cairia no Unmatched Route.
 *
 * ⚠️ Ao incluir uma área aqui, mapear a rota nos dois lados: no
 * admin-config-service-node (`notification-screen-routes.ts`) e no app
 * (`src/models/notifications.ts`).
 */
export const NOTIFICATION_TARGET_COMPONENTS: ApplicationComponentId[] = [
  ApplicationComponentId.HOME,
  ApplicationComponentId.NEWS,
  ApplicationComponentId.CALENDAR,
  ApplicationComponentId.TABLES,
  ApplicationComponentId.TEAM,
  ApplicationComponentId.HISTORY,
  ApplicationComponentId.INDICATIONS_MAP,
  ApplicationComponentId.VIDEOS_CHANNEL,
  ApplicationComponentId.POSTS,
  ApplicationComponentId.POLLS,
  ApplicationComponentId.PREDICTIONS,
  ApplicationComponentId.STORE,
  // Páginas do site do parceiro — o app resolve cada id em PARTNER_URL + path.
  ApplicationComponentId.BALADA_APP_HOME,
  ApplicationComponentId.BALADA_APP_ACCOUNT,
  ApplicationComponentId.BALADA_APP_PLANS,
  ApplicationComponentId.BALADA_APP_GAMES,
];
